import { render, staticRenderFns } from "./ContactosDetalle.vue?vue&type=template&id=23c72268&scoped=true"
import script from "./ContactosDetalle.vue?vue&type=script&lang=js"
export * from "./ContactosDetalle.vue?vue&type=script&lang=js"
import style0 from "./ContactosDetalle.vue?vue&type=style&index=0&id=23c72268&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23c72268",
  null
  
)

export default component.exports